import { render, staticRenderFns } from "./bloodApp.vue?vue&type=template&id=326afe96&"
import script from "./bloodApp.vue?vue&type=script&lang=js&"
export * from "./bloodApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports